// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AutomationQueries } from '../../../../types/server/modules/automation/queries';

export type * from '../../../../types/server/modules/automation/queries';

export const createQueries = ( requests: Requests ): AutomationQueries => ({
  RulesById: ( id, query, headers ) => { 
          return requests.get( `/rules/${id}`, query, headers ); 
        },
  Rules: ( params?, headers? ) => {
        return requests.get( `/rules/:id?`, params, headers );
      },
  StockThresholdsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/stock-thresholds-readmodel/${id}`, query, headers ); 
        },
  StockThresholdsReadmodel: ( params?, headers? ) => {
        return requests.get( `/stock-thresholds-readmodel/:id?`, params, headers );
      },
  RuleDefinitionsById: ( id, query, headers ) => { 
          return requests.get( `/rule-definitions/${id}`, query, headers ); 
        },
  RuleDefinitions: ( params?, headers? ) => {
        return requests.get( `/rule-definitions/:id?`, params, headers );
      },
  AutomationRequestsById: ( id, query, headers ) => { 
          return requests.get( `/automation-requests/${id}`, query, headers ); 
        },
  AutomationRequests: ( params?, headers? ) => {
        return requests.get( `/automation-requests/:id?`, params, headers );
      },
  AutomationRequestsSummary: ( params?, headers? ) => {
        return requests.get( `/automation-requests-summary`, params, headers );
      },
  RuleExecutionsById: ( id, query, headers ) => { 
          return requests.get( `/rule-executions/${id}`, query, headers ); 
        },
  RuleExecutions: ( params?, headers? ) => {
        return requests.get( `/rule-executions/:id?`, params, headers );
      },
  RuleExecutionsSearch: ( params?, headers? ) => {
        return requests.get( `/rule-executions-search/:search?`, params, headers );
      },
  RuleExecutionsStatusCounts: ( params?, headers? ) => {
        return requests.get( `/rule-executions-status-counts`, params, headers );
      },
  RuleExecutionBatches: ( params?, headers? ) => {
        return requests.get( `/rule-execution-batches/:correlationId?`, params, headers );
      },
  RuleExecutionBatchesSearch: ( params?, headers? ) => {
        return requests.get( `/rule-execution-batches-search/:search?`, params, headers );
      }
});
